import { useEffect, type ReactElement } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCanEdit } from "./auth/useCanEdit";
import { consumePostLoginPath, isFloorplanPath } from "./auth/postLoginRedirect";
import { useSession } from "./session/hooks";

/**
 * After MSAL returns to the app root, send non-Editors back to the
 * floor plan only when that is the page they opened before signing in.
 * Editors keep the default landing / admin index behavior.
 */
export function PostLoginRedirect(): ReactElement | null {
    const navigate = useNavigate();
    const location = useLocation();
    const session = useSession();
    const canEdit = useCanEdit();

    useEffect(() => {
        if (!session.isSuccess) return;

        const pending = consumePostLoginPath();
        if (pending === null) return;
        // Only non-Editors are sent to a remembered floor-plan deep link.
        if (canEdit) return;
        if (!isFloorplanPath(pending)) return;

        if (location.pathname + location.search === pending) return;
        navigate(pending, { replace: true });
    }, [session.isSuccess, canEdit, location.pathname, location.search, navigate]);

    return null;
}
